const routes =[
  {
    path: '/pay/index',
    name: 'pay',
    meta: {
      title: '支付',
    },
    component: () => import('@/views/pay/index'),
  },
  {
    path: '/pay/payResult',
    name: 'payResult',
    meta: {
      title: '支付结果',
    },
    component: () => import('@/views/pay/payResult'),
  },
];
export default [
  {
    path: '/main/Layout',
    component: () => import('@/views/main/Layout.vue'),
    children: [
      ...routes,
    ],
  },
];

